<template>
  <div :class="{ 'large-btn': isLarge }">
    <div
      class="item-avatar"
      :class="{ 'large': isLarge }"
      :style="'background-color: ' + bgColor + ';'"
      @mouseenter="hover = true"
      @mouseleave="hover = false"
    >
      <img v-if="!isLarge || !hover" :src="imgUrl" :style="imgStyle" alt="img" />
      <img v-if="isLarge && hover" src="@/assets/images/edit_white.svg" alt="img" />
    </div>
    <div v-if="isLarge && !hover" class="card-name">
      <span v-for="name in names" :key="name" class="card-text ">{{ name }}</span>
    </div>
    <div v-if="isLarge && hover" class="card-name">
      <span class="card-text ">Edit</span>
    </div>
    <div v-if="isNeedRecording" class="play-recording" @click.stop="onEditRecording">
      <img :src="routeRecordingImgUrl" alt="route_recordig" />
    </div>
  </div>
</template>

<script>
import { ROUTE_TYPES, ACTION_TYPES } from '@/constants';
export default {
  name: 'CallFlowButtonIcon',
  props: {
    action: String,
    type: String,
    enabledRouting: Boolean,
    names: Array
  },
  data: () => ({
    hover: false
  }),
  computed: {
    isLarge() {
      return this.type === 'large';
    },
    isNeedRecording() {
      return (
        this.type === 'large' &&
        (this.action === ACTION_TYPES.ACTION_PERSON || this.action === ACTION_TYPES.ACTION_GROUP)
      );
    },
    routeRecordingImgUrl() {
      const images = require.context('@/assets/images', false, /\.svg$/);
      const imageName = this.enabledRouting ? 'route_recording_enable' : 'route_recording_disable';
      return images('./' + imageName + '.svg');
    },
    imgUrl() {
      const images = require.context('@/assets/images', false, /\.svg$/);
      let imageName = '';
      switch (this.action) {
        case ACTION_TYPES.ACTION_MENU:
          imageName = 'call_menu';
          break;
        case ACTION_TYPES.ACTION_PERSON:
          imageName = 'person_white';
          break;
        case ACTION_TYPES.ACTION_GROUP:
          imageName = 'group_white';
          break;
        case ACTION_TYPES.ACTION_VOICEMAIL:
          imageName = 'voice_mail_3';
          break;
        case ACTION_TYPES.ACTION_HANGUP:
          imageName = 'hang_up';
          break;
        default:
          break;
      }
      return images('./' + imageName + '.svg');
    },
    imgStyle() {
      let imageStyle = '';
      if (this.type === 'large') {
        imageStyle += 'transform: scale(1.3);';
      }
      return imageStyle;
    },
    bgColor() {
      switch (this.action) {
        case ACTION_TYPES.ACTION_AUDIO:
          return '#6D778A';
        case ACTION_TYPES.ACTION_MENU:
          return '#C2C7CF';
        case ACTION_TYPES.ACTION_PERSON:
          return '#819F77';
        case ACTION_TYPES.ACTION_GROUP:
          return '#77A9D7';
        case ACTION_TYPES.ACTION_VOICEMAIL:
          return '#6D67AC';
        default:
          return '#CC2F2F';
      }
    }
  },
  methods: {
    onEditRecording() {
      this.$emit('edit-recording');
    }
  }
};
</script>

<style scoped lang="scss">
.large-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.card-name {
  padding-top: 10px;
  height: 30px;
  align-items: center;

  .card-text {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    letter-spacing: -0.01em;
    color: #0d1d3f;
    display: block;
    white-space: nowrap;
  }
}

.play-recording {
  position: absolute;
  top: -16px;
  right: -16px;
}

.item-avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  border-radius: 5px;

  &.large {
    width: 45px;
    height: 45px;
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 0px 3px 2px rgba(83, 95, 119, 0.2), 0px 2px 10px rgba(83, 95, 119, 0.15);
  }
}
</style>
